import { render, staticRenderFns } from "./EdgeTable.vue?vue&type=template&id=4889e842&scoped=true"
import script from "./EdgeTable.vue?vue&type=script&lang=js"
export * from "./EdgeTable.vue?vue&type=script&lang=js"
import style0 from "./EdgeTable.vue?vue&type=style&index=0&id=4889e842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889e842",
  null
  
)

export default component.exports